import axios from 'axios'

export const getAllAssets = async () => {
  const { data } = await axios.get('/api/assets')
  return data
}

// Admin catalog: every asset enriched with usageLive / usageReview / usageTotal.
export const getAdminAssets = async () => {
  const { data } = await axios.get('/api/assets/admin')
  return data
}

// Batch file sizes for a tab's blobs -> { [blob]: sizeBytes|null }.
export const getAssetSizes = async (blobs) => {
  const { data } = await axios.post('/api/assets/sizes', { blobs })
  return data
}

export const addAsset = async (type, id, url, blob, ext, hex) => {
  const { data } = await axios.post('/api/assets/add', { type, id, url, blob, ext, hex })
  return data
}

// Edit in place. Image: { url, blob, ext }. Color: { hex }. id/blob are the key.
export const updateAsset = async (type, id, patch) => {
  const { data } = await axios.put(`/api/assets/${type}/${encodeURIComponent(id)}`, patch)
  return data
}

// Delete: backend removes the Firebase file (if any) + pulls it from the catalog.
export const deleteAsset = async (type, id) => {
  const { data } = await axios.delete(`/api/assets/${type}/${encodeURIComponent(id)}`)
  return data
}
